import { FFmpeg } from "@ffmpeg/ffmpeg";
import { fetchFile } from "@ffmpeg/util";

declare global {
  interface Window {
    webkitAudioContext?: typeof AudioContext;
  }
}

const ffmpeg = new FFmpeg();

// async function getNoiseFloor(audioFile: File): Promise<number> {
//   return new Promise<number>((resolve, reject) => {
//     const reader = new FileReader();
//     reader.readAsArrayBuffer(audioFile);
//     reader.onload = async (event) => {
//       const arrayBuffer = event.target?.result as ArrayBuffer;
//       const AudioContext = window.AudioContext || window.webkitAudioContext;
//       if (!AudioContext) {
//         throw new Error("이 브라우저는 Web Audio API를 지원하지 않습니다");
//       }
//       const audioContext = new AudioContext();

//       try {
//         const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
//         const rawData = audioBuffer.getChannelData(0); // 첫 번째 채널 데이터

//         const frameSize = 1024;
//         const numFrames = Math.floor(rawData.length / frameSize);
//         const rmsValues: number[] = [];

//         // 각 프레임의 RMS 계산
//         for (let i = 0; i < numFrames; i++) {
//           let sum = 0;
//           for (let j = 0; j < frameSize; j++) {
//             const sample = rawData[i * frameSize + j];
//             sum += sample * sample;
//           }
//           const rms = Math.sqrt(sum / frameSize);
//           rmsValues.push(rms);
//         }

//         // RMS 값을 정렬하고 5번째 퍼센타일을 노이즈 플로어로 사용
//         rmsValues.sort((a, b) => a - b);
//         const percentileIndex = Math.floor(rmsValues.length * 0.05);
//         const noiseFloorRms = rmsValues[percentileIndex] || Number.EPSILON;
//         const noiseFloorDb = 20 * Math.log10(noiseFloorRms);

//         resolve(noiseFloorDb);
//       } catch (error) {
//         reject(error);
//       } finally {
//         // AudioContext 종료
//         audioContext.close();
//       }
//     };
//     reader.onerror = (error) => reject(error);
//   });
// }

// export async function normalizeAudioFile(audioFile: File): Promise<File> {
//   try {
//     if (!ffmpeg.loaded) {
//       await ffmpeg.load();
//       console.log("FFmpeg loaded successfully");
//     }

//     // 노이즈 플로어 계산
//     const noiseFloorDb = await getNoiseFloor(audioFile);
//     const noiseGateThreshold = noiseFloorDb + 5;
//     console.log(
//       `Calculated noise gate threshold: ${noiseGateThreshold.toFixed(2)} dB`
//     );

//     const inputFileName = `input_audio.${audioFile.name.split(".").pop()}`;
//     const gatedFileName = "gated_audio.wav";
//     const outputFileName = "normalized_output.mp3";

//     // Write the file to FFmpeg's virtual file system
//     console.log(`Writing file to FFmpeg: ${inputFileName}`);
//     await ffmpeg.writeFile(inputFileName, await fetchFile(audioFile));
//     console.log("File written successfully to FFmpeg virtual file system");

//     // 1단계: 노이즈 게이트 적용
//     console.log("노이즈 게이트 적용 중...");
//     await ffmpeg.exec([
//       "-i",
//       inputFileName,
//       "-af",
//       `agate=threshold=${noiseGateThreshold}dB:ratio=10:attack=20:release=250:detection=rms`,
//       "-c:a",
//       "pcm_s16le",
//       gatedFileName,
//     ]);
//     console.log("노이즈 게이트 적용 완료");

//     // Run the FFmpeg command to normalize the audio
//     console.log("Starting normalization process...");
//     await ffmpeg.exec([
//       "-i",
//       gatedFileName,
//       "-af",
//       `agate=threshold=${noiseGateThreshold}dB:detection=peak, loudnorm=I=-14:LRA=11:TP=-1.5`,
//       "-c:a",
//       "libmp3lame",
//       "-b:a",
//       "192k",
//       outputFileName,
//     ]);
//     console.log("Normalization completed successfully");

//     const data = await ffmpeg.readFile(outputFileName);
//     console.log(`File read successfully: ${outputFileName}`);

//     const normalizedBlob = new Blob([data], { type: "audio/mpeg" });

//     const normalizedFile = new File([normalizedBlob], audioFile.name, {
//       type: "audio/mpeg",
//     });

//     await ffmpeg.deleteFile(inputFileName);
//     await ffmpeg.deleteFile(outputFileName);
//     console.log("Files cleaned up successfully");

//     return normalizedFile;
//   } catch (error) {
//     console.error("Error normalizing audio file:", error);
//     throw error;
//   }
// }

async function getNoiseFloor(audioFile: File): Promise<number> {
  return new Promise<number>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(audioFile);
    reader.onload = async (event) => {
      const arrayBuffer = event.target?.result as ArrayBuffer;
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      if (!AudioContext) {
        throw new Error("이 브라우저는 Web Audio API를 지원하지 않습니다");
      }
      const audioContext = new AudioContext();

      try {
        const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
        const rawData = audioBuffer.getChannelData(0); // 첫 번째 채널 데이터

        const frameSize = 1024;
        const numFrames = Math.floor(rawData.length / frameSize);
        const rmsValues: number[] = [];

        // 각 프레임의 RMS 계산
        for (let i = 0; i < numFrames; i++) {
          let sum = 0;
          for (let j = 0; j < frameSize; j++) {
            const sample = rawData[i * frameSize + j];
            sum += sample * sample;
          }
          const rms = Math.sqrt(sum / frameSize);
          rmsValues.push(rms);
        }

        // RMS 값을 정렬하고 5번째 퍼센타일을 노이즈 플로어로 사용
        rmsValues.sort((a, b) => a - b);
        const percentileIndex = Math.floor(rmsValues.length * 0.05);
        const noiseFloorRms = rmsValues[percentileIndex] || Number.EPSILON;
        const noiseFloorDb = 20 * Math.log10(noiseFloorRms);

        resolve(noiseFloorDb);
      } catch (error) {
        reject(error);
      } finally {
        // AudioContext 종료
        audioContext.close();
      }
    };
    reader.onerror = (error) => reject(error);
  });
}

export async function normalizeAudioFile(audioFile: File): Promise<File> {
  try {
    if (!ffmpeg.loaded) {
      await ffmpeg.load();
      console.log("FFmpeg loaded successfully");
    }

    return audioFile;

    // 노이즈 플로어 계산
    const noiseFloorDb = await getNoiseFloor(audioFile);
    const noiseGateThreshold = noiseFloorDb + 5;
    console.log(
      `Calculated noise gate threshold: ${noiseGateThreshold.toFixed(2)} dB`
    );

    const inputFileName = `input_audio.${audioFile.name.split(".").pop()}`;
    const gatedFileName = "gated_audio.wav";
    const outputFileName = "normalized_output.mp3";

    // Write the file to FFmpeg's virtual file system
    console.log(`Writing file to FFmpeg: ${inputFileName}`);
    await ffmpeg.writeFile(inputFileName, await fetchFile(audioFile));
    console.log("File written successfully to FFmpeg virtual file system");

    // 1단계: 노이즈 게이트 적용
    console.log("Applying noise gate...");
    await ffmpeg.exec([
      "-i",
      inputFileName,
      "-af",
      `agate=threshold=${noiseGateThreshold}dB:ratio=4:attack=100:release=300:detection=peak`,
      "-c:a",
      "pcm_s16le",
      gatedFileName,
    ]);
    console.log("Noise gate applied successfully");

    // 2단계: 분석 (1차 패스)
    console.log("Analyzing audio for normalization...");
    const analysisResult = await ffmpeg.exec([
      "-i",
      gatedFileName,
      "-af",
      "loudnorm=I=-14:LRA=11:TP=-1.5:print_format=json",
      "-f",
      "null",
      "-",
    ]);
    const analysis = JSON.parse(String(analysisResult));
    console.log("Analysis completed:", analysis);

    const measured_I = analysis.input_i;
    const measured_LRA = analysis.input_lra;
    const measured_TP = analysis.input_tp;
    const measured_thresh = analysis.input_thresh;
    const offset = analysis.target_offset;

    // 3단계: 노멀라이제이션 및 다이내믹 레인지 컴프레션 적용 (2차 패스)
    console.log("Applying normalization and compression...");
    await ffmpeg.exec([
      "-i",
      gatedFileName,
      "-af",
      `loudnorm=I=-14:LRA=11:TP=-1.5:measured_I=${measured_I}:measured_LRA=${measured_LRA}:measured_TP=${measured_TP}:measured_thresh=${measured_thresh}:offset=${offset}:linear=true,acompressor=threshold=-20dB:ratio=4:attack=100:release=300`,
      "-c:a",
      "libmp3lame",
      "-b:a",
      "192k",
      outputFileName,
    ]);
    console.log("Normalization and compression applied successfully");

    const data = await ffmpeg.readFile(outputFileName);
    console.log(`File read successfully: ${outputFileName}`);

    const normalizedBlob = new Blob([data], { type: "audio/mpeg" });

    const normalizedFile = new File([normalizedBlob], audioFile.name, {
      type: "audio/mpeg",
    });

    // Clean up virtual file system
    await ffmpeg.deleteFile(inputFileName);
    await ffmpeg.deleteFile(gatedFileName);
    await ffmpeg.deleteFile(outputFileName);
    console.log("Files cleaned up successfully");

    return normalizedFile;
  } catch (error) {
    console.error("Error normalizing audio file:", error);
    throw error;
  }
}
